import { gql } from "apollo-boost"

export const getProjects = gql`
  query getProjects ($where: DashboardProjectsWhere){
    DashboardProjects (where: $where) {
      id
      name
      approved
      status
      concepts {
        region
      }
      budgeted
      region
      startDate
      endDate
      evidenced
      implementer {
        id
        name
      }
      invoices {
        id
        createdAt
        ficosecPayment
      }
      beneficiaries {
        id
        number
      }
    }
  }
`